"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageCategoryTemplate;
(function (PageCategoryTemplate) {
    PageCategoryTemplate["Retail"] = "retail";
    PageCategoryTemplate["Service"] = "service";
    PageCategoryTemplate["Informative"] = "informative";
})(PageCategoryTemplate = exports.PageCategoryTemplate || (exports.PageCategoryTemplate = {}));
;
//# sourceMappingURL=page-category-template.enum.js.map